module.exports = __webpack_public_path__ + "img/rwanda-ambulance.4bccf1cb.jpeg";